export default "__VITE_ASSET__BXASSv16__"